import type { AppModule } from '@/core/register-modules';

import * as routes from './routes';

export const NumeralsModule: AppModule = {
  routes,
};
